module.exports = __webpack_public_path__ + "img/5304.04ca1464.png";